<template>
    <div class="history-search-container">
        <!-- Date pickers row -->
        <div class="row mb-2">
            <div class="col-md-4 col-6 mb-2 mb-md-0">
                <div class="container-search">
                    <i :class="!fromDate ? 'bi bi-calendar2 calender' : 'bi bi-x-circle calender'"
                        @click="!fromDate ? openFromCalendar() : clearFromDate()"></i>
                    <datepicker :placeholder="getTranslatedText(`select from date`)" input-class="form-control "
                        :typeable="true" v-model="fromDate" :format="formatDate" ref="fromDatepicker"
                        @selected="handleFromDateChange" :disabledDates="disabledFromDates" class="select-date"
                        tabname="select-date" />
                </div>
            </div>
            <div class="col-md-4 col-6 mb-2 mb-md-0">
                <div class="container-search">
                    <i :class="!toDate ? 'bi bi-calendar2 calender' : 'bi bi-x-circle calender'"
                        @click="!toDate ? openToCalendar() : clearToDate()"></i>
                    <datepicker :placeholder="getTranslatedText(`select to date`)" input-class=" form-control"
                        :typeable="true" v-model="toDate" :format="formatDate" ref="toDatepicker"
                        @selected="handleToDateChange" :disabledDates="disabledToDates" class="select-date"
                        tabname="select-date" />
                </div>
            </div>
            <!-- Search input - hidden on mobile, shown on desktop -->
            <div class="col-md-4 d-none d-md-block">
                <div class="container-search">
                    <i class="search bi bi-search"></i>
                    <input type="text" :placeholder="getTranslatedText('search by transaction id')"
                        class=" form-control search-data" @input="handleInputChange" />
                </div>
            </div>
        </div>
        
        <!-- Search input row - shown only on mobile -->
        <div class="row d-md-none">
            <div class="col-12">
                <div class="container-search">
                    <i class="search bi bi-search"></i>
                    <input type="text" :placeholder="getTranslatedText('search by transaction id')"
                        class=" form-control search-data" @input="handleInputChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import Datepicker from "@hokify/vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css";

export default {
    name: 'HistorySearch',
    components: { Datepicker },
    mixins: [languageMixins],
    data() {
        return {
            fromDate: null,
            toDate: null,
            formatDate: 'DD/MM/yyyy',
            disabledFromDates: {},
            disabledToDates: {},
            transactionId: null
        }
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.disabledFromDates = {
                from: new Date()
            }
            this.disabledToDates = {
                from: new Date()
            }
        },

        handleFromDateChange() {
            setTimeout(() => {
                this.disabledToDates = {
                    to: this.fromDate,
                    from: new Date()
                }

                if (this.fromDate && this.toDate) {
                    this.$emit('search', {
                        fromDate: this.fromDate,
                        toDate: this.toDate,
                        transactionId: this.transactionId
                    });
                }
            }, 100)
        },

        handleToDateChange() {
            setTimeout(() => {
                this.disabledFromDates = {
                    from: this.toDate,
                }

                if (this.fromDate && this.toDate) {
                    this.$emit('search', {
                        fromDate: this.fromDate,
                        toDate: this.toDate,
                        transactionId: this.transactionId
                    });
                }
            }, 100)
        },

        clearFromDate() {
            this.disabledToDates = {
                from: new Date()
            }
            this.fromDate = null
            if (!this.fromDate && !this.toDate) {
                this.$emit('search', {
                    fromDate: null,
                    toDate: this.toDate,
                    transactionId: this.transactionId
                });
            }
        },

        clearToDate() {
            this.disabledFromDates = {
                from: new Date()
            }
            this.toDate = null
            if (!this.fromDate && !this.toDate) {
                this.$emit('search', {
                    fromDate: this.fromDate,
                    toDate: null,
                    transactionId: this.transactionId
                });
            }
        },

        openFromCalendar() {
            this.$refs.fromDatepicker.showCalendar()
        },

        openToCalendar() {
            this.$refs.toDatepicker.showCalendar()
        },

        handleInputChange(e) {
            this.transactionId = e.target.value
            this.$emit('search', {
                fromDate: this.fromDate,
                toDate: this.toDate,
                transactionId: this.transactionId
            });
        }
    }
}
</script> 